export const SET_NGUON_HANG = 'SET_NGUON_HANG'
export const SET_EDIT_NGUON_HANG = 'SET_EDIT_NGUON_HANG'

// saga

export const Lay_DANH_SACH_NGUON_HANG_SAGA = 'Lay_DANH_SACH_NGUON_HANG_SAGA'
export const TIM_KIEM_NGUON_HANG_SAGA = 'TIM_KIEM_NGUON_HANG_SAGA'
export const THEM_NGUON_HANG_SAGA = 'THEM_NGUON_HANG_SAGA';
export const XOA_NGUON_HANG_SAGA = 'XOA_NGUON_HANG_SAGA';
export const EDIT_NGUON_HANG_SAGA = 'EDIT_NGUON_HANG_SAGA';